
import { mapState } from 'vuex';
import { generateCategoryUrl, getAllActiveCategories } from '@/plugins/helpers/catalog';

export default {
  name: 'CategoriesTree',
  props: {
    itemCategory: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'catalog',
    },
  },
  computed: {
    ...mapState('route', {
      entityCode: (state) => state.params.entityCode,
      category: (state) => state.params.category,
    }),
    ...mapState('catalog', {
      allCategories: 'allCategories',
    }),
    url() {
      const {
        type,
        entityCode,
        itemCategory: { code },
      } = this;

      const query = { ...this.$route.query };
      delete query.page;
      return {
        path: generateCategoryUrl(type, entityCode, code),
        query,
      };
    },
    hasChildren() {
      const {
        itemCategory: { items },
      } = this;
      return Array.isArray(items);
    },
    isRoot() {
      return this.hasChildren && !this.depth;
    },
    isCurrent() {
      return this.category === this.itemCategory.code;
    },
    activeCategories() {
      const list = getAllActiveCategories(this.allCategories, this.category);
      return Array.from(list, item => item.code);
    },
    visibleChildren() {
      return this.activeCategories.includes(this.itemCategory.code);
    },
  },
};
